module.exports = __webpack_public_path__ + "static/media/CFX-Program.8544e9d4.pdf";